"use client";

import { componentCls } from "@faire/slate/lib/tracking";
import { tsv } from "@faire/slate/lib/tsv";
import { useFloatingContext } from "@faire/slate/private/floating/FloatingContext";
import React from "react";

type IProps = {
  children?: React.ReactNode;
  "data-component-name"?: string;
  id: string;
  title: string;
  zIndex?: number;
};

export const FilterMenuBase: React.FC<IProps> = ({
  children,
  "data-component-name": dataComponentName,
  id,
  title,
  zIndex,
}) => {
  const { floatingStyles, propGetters, refs } = useFloatingContext();
  const contentCls = contentStyle.cls({ className: componentCls() });
  const contentVars = contentStyle.vars({ zIndex });

  return (
    <div
      {...propGetters.getFloatingProps({
        "aria-label": title,
        className: contentCls,
        id,
        ref: refs.setFloating,
        style: { ...contentVars, ...floatingStyles },
      })}
      data-component-name={dataComponentName}
    >
      {children}
    </div>
  );
};

const contentStyle = tsv({
  vars: {
    zIndex: "fs-filter-menu-z-index",
  },
  base: "fs-filter-menu z-(--fs-filter-menu-z-index)",
});
